import { TextInput } from '@core/components/Inputs';
import { Fade, FormControlLabel, Grid, Switch } from '@material-ui/core';
import { SelectGrupoAcesso } from 'app/components/Select';
import SelectVendedor from 'app/components/Select/SelectVendedor';
import { useFormikContext } from 'formik';
import React from 'react';
import { useDadosGeraisUsuarioStyles } from './styles';

const TabDadosGeraisUsuario = () => {
  const formik = useFormikContext();

  const styles = useDadosGeraisUsuarioStyles();

  const _errors = {
    nome: (formik.touched.nome || formik.submitCount > 0) && formik.errors.nome,
    email: (formik.touched.email || formik.submitCount > 0) && formik.errors.email,
    grupoAcesso: (formik.touched.grupoAcesso?.id || formik.submitCount > 0) && formik.errors.grupoAcesso?.id,
    vendedor: (formik.touched.vendedor || formik.submitCount > 0) && formik.errors.vendedor,
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="nome"
          name="nome"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.nome}
          error={_errors.nome}
          touched={formik.touched.nome}
          required
          fullWidth
          autoFocus
          variant="outlined"
          label="Nome"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <TextInput
          id="email"
          name="email"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.email}
          error={_errors.email}
          touched={formik.touched.email}
          disabled={!!formik.values.id}
          required
          fullWidth
          variant="outlined"
          label="E-mail"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
        <SelectGrupoAcesso
          id="grupoAcesso"
          handleChange={formik.handleChange}
          handleBlur={formik.handleBlur}
          value={formik.values?.grupoAcesso}
          error={_errors.grupoAcesso}
          touched={formik.touched.grupoAcesso}
          required
          fullWidth
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <div className={styles.containerVendedor}>
          <FormControlLabel
            control={
              <Switch
                id="bindVendedor"
                name="bindVendedor"
                value={formik.values?.bindVendedor}
                checked={formik.values?.bindVendedor}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                color="primary"
              />
            }
            label="Usuário é um vendedor"
          />
          <Fade in={!!formik.values.bindVendedor}>
            <div className={styles.containerNomeVendedor}>
              <SelectVendedor
                id="vendedor"
                fullWidth
                required
                label="Nome do vendedor"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.vendedor}
                error={_errors.vendedor}
                touched={formik.touched.vendedor}
              />
            </div>
          </Fade>
        </div>
      </Grid>
    </Grid>
  );
};

export default TabDadosGeraisUsuario;
